/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessDto implements Wars.Domain.Model.Dtos.ProcessDto {
        rowMetadata: Collections.Dictionary<string, Wars.Domain.Model.Dtos.RowMetadataDto>;
        featureToRows: Collections.Dictionary<string, Wars.Domain.Model.Dtos.FeatureToRowDto>;
        features: Wars.Domain.Model.Dtos.FeatureDto[];
        metadata: Collections.Dictionary<string, string>;
        commentThreads: Collections.Dictionary<string, Wars.Domain.Model.Dtos.CommentThreadSectionDto>;
        assignmentSections: Collections.Dictionary<string, Wars.Domain.Model.Dtos.AssignmentSectionDto>;
        formJson: Collections.Dictionary<string, Collections.Dictionary<string, string>>;
        processData:  Collections.Dictionary<string, string>;
        containersVisibilities: Collections.Dictionary<string, boolean>;
        formsVisibilities: Collections.Dictionary<string, Wars.Domain.Model.Dtos.FormVisibility>;
        userActions: Wars.Domain.Model.Dtos.Workflow.UserActionDto[];
        processConfigurationId: string;
        id: string;
        stateCodeUniqueId: string;
        formDatas: Wars.Domain.Model.Dtos.FormDataDto[];
        reviewSets: Wars.Domain.Model.Dtos.ReviewSetDto[];
        statusHistories: Wars.Domain.Model.Dtos.StatusHistoryDto[];
        effectiveDateErrorMessage: string;
        showTimeForInvalidEffective: boolean;
        successMessages: string[];
        infoMessages: string[];
        warnMessages: string[];
        errorMessages: string[];
        documentsToDownload: string[];
        conditionStates: Collections.Dictionary<string, boolean>;
        propertyConditionDependencies: Collections.Dictionary<string, Wars.Domain.Model.Dtos.PropertyConditionDependencyDto>;
        processAssignments: Wars.Domain.Model.Dtos.ProcessAssignmentDto[];
        processHeaders: string[];
        documents: Wars.Domain.Model.Dtos.DocumentDto[];
        documentSections: Collections.Dictionary<string, Wars.Domain.Model.Dtos.ManageDocumentSectionDto>;
        customStepFunctions: Collections.Dictionary<string, Wars.Domain.Model.Dtos.CustomFunctionDto[]>;
        clockValues: Wars.Domain.Model.Clocks.ClockValue[];
        canDownloadSecureDocument: Collections.Dictionary<string, boolean>;
        canSecureDocment: Collections.Dictionary<string, boolean>;
        canReplyToManageStatusSectionCommentThreads: Collections.Dictionary<string, boolean>;
        processNames: Collections.Dictionary<string, string>;
        processEvents: Wars.Domain.Model.Dtos.ProcessEventDto[];
        processEventActions: Wars.Domain.Model.Dtos.ProcessEventActionDto[];
        flatStatusHistories: Wars.Domain.Model.Dtos.FlatStatusHistoryDto[];
    }
}